module.exports = __webpack_public_path__ + "static/media/47.c5dced28.jpg";